import { BATCH_ADD, BATCH_EDIT, BATCH_VIEW, BATCH_PLANT_ADD, PLANT_VIEW } from '@/utils/permissions'

export default [
  {
    path: '/batches/list',
    name: 'batch-list',
    component: () => import('@/views/batches/BatchLayout.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Batch List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Batch' }, { title: 'Batches List', active: true }],
      permissions: [BATCH_VIEW]
    }
  },
  //inactive batches
  {
    path: '/batches/inactive',
    name: 'inactive-batch-list',
    component: () => import('@/views/batches/InactiveBatchList.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Inactive Batch List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Batch' }, { title: 'Inactive List', active: true }],
      permissions: [BATCH_VIEW]
    }
  },
  {
    path: '/batches/create',
    name: 'create-batch',
    component: () => import('@/views/batches/AddBatch.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Add batch',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Batch', url: '/batches/list' },
        { title: 'Add batch', active: true }
      ],
      permissions: [BATCH_ADD]
    }
  },
  {
    path: '/batches/new-list',
    name: 'batch-new-list',
    component: () => import('@/views/batches/BatchNewList.vue'),
    props: { isArchievedList: false },
    meta: {
      allowAnonymous: false,
      pageTitle: 'Batch List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Batch' }, { title: 'Batches List', active: true }],
      permissions: [BATCH_VIEW]
    }
  },

  // edit batch
  {
    path: '/batches/:id/edit',
    name: 'edit-batch',
    component: () => import('@/views/batches/EditBatch.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Batch',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Batch', url: '/batches/list' },
        { title: 'Edit batch', active: true }
      ],
      permissions: [BATCH_EDIT]
    }
  },
  // view batch
  {
    path: '/batches/:id/view',
    name: 'view-batch',
    component: () => import('@/views/batches/ViewBatch.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'View Batch',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Batch', url: '/batches/list' },
        { title: 'View Batch', active: true }
      ],
      permissions: [BATCH_EDIT]
    }
  },

  {
    path: '/batches/:batchId/plants/create',
    name: 'create-batch-plant',
    component: () => import('@/views/batches/components/plants/AddPlant.vue'),
    props: { reditectTo: '/batches/:batchId/view' },
    meta: {
      allowAnonymous: false,
      pageTitle: 'Create Batch Plant',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Plant', url: '/batches/list' },
        { title: 'Add Plant', active: true }
      ],
      permissions: [BATCH_PLANT_ADD]
    }
  },

  {
    path: '/batches/:batchId/plants/:id/edit',
    name: 'edit-batch-plant',
    component: () => import('@/views/batches/components/plants/EditPlant.vue'),
    props: { reditectTo: '/batches/:batchId/view' },
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Batch Plant',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Plant', url: '/plants/list' },
        { title: 'Edit Plant', active: true }
      ],
      permissions: [BATCH_PLANT_ADD]
    }
  },
  {
    path: '/plants/:id/edit',
    name: 'edit-plant',
    component: () => import('@/views/batches/components/plants/EditPlant.vue'),
    props: { reditectTo: '/plants/list' },
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Plant',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Plant', url: '/plants/list' },
        { title: 'Edit Plant', active: true }
      ],
      permissions: [BATCH_PLANT_ADD]
    }
  },
  {
    path: 'plants/list',
    name: 'plant-list',
    component: () => import('@/views/batches/PlantList.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Plant List',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Plant List', active: true }
      ],
      permissions: [PLANT_VIEW]
    }
  },
  {
    path: '/batches/:batchId/batch-weight-summary',
    name: 'batch-weight-summary',
    component: () => import('@/views/batches/BatchWeightSummary.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Batch Weight Summary',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Batch', url: '/batches/list' },
        { title: 'Batch Weight Summary', active: true }
      ]
    }
  },
  {
    path: '/batches/:batchId/archive-batch-plants',
    name: 'archive-batch-plants',
    component: () => import('@/views/batches/ArchieveBatchPlants.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Archive Batch Plants',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Batch', url: '/batches/list' },
        { title: 'Archived Batch Plants', active: true }
      ]
    }
  },
  {
    path: '/batches/:batchId/print-label',
    name: 'batch-print-label',
    component: () => import('@/views/batches/PrintLabel.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Batch Print Label',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Batch', url: '/batches/list' },
        { title: 'Batch Print Label', active: true }
      ]
    }
  }
]
